import { useState } from "react";
import { Form, Row, Col } from "react-bootstrap";
import { toast } from "react-toastify";
import contactUsImg from "../assets/contact-us/contact-us.webp";
import { useSendContactMessageMutation } from "../slices/contactUsSlice"; // Import the hook
import { Spinner } from 'react-bootstrap';

const ContactUs = () => {
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [issue, setIssue] = useState("");
  const [agreed, setAgreed] = useState(false);

  // Use RTK Query mutation hook
  const [sendContactMessage, { isLoading }] = useSendContactMessageMutation();

  const submitHandler = async (e) => {
    e.preventDefault();

    if (!agreed) {
      toast.error("יש לאשר את תקנון האתר");
      return;
    }

    try {
      await sendContactMessage({
        email,
        phone,
        issue,
      }).unwrap();

      // Success
      toast.success("פנייתך התקבלה בהצלחה");
      setEmail("");
      setPhone("");
      setIssue("");
      setAgreed(false);
    } catch (err) {
      console.error("Contact form error:", err);
      toast.error(err?.data?.message || "התרחשה שגיאה - נסה שנית");
    }
  };

  return (
    <>
      <section
        className="contact_us_background"
        style={{
          marginTop: "12rem",
          marginRight: "calc(-50vw + 50%)",
          marginLeft: "calc(-50vw + 50%)",
          width: "100vw",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-5">
              <div className="image-container mt-n6 mb-5">
                <img
                  src={contactUsImg}
                  alt=""
                  className="img-fluid"
                  style={{ marginTop: "-6rem" }}
                />
              </div>
            </div>
            <div className="col-lg-7">
              <div className="text-container text-white d-flex flex-column justify-content-center h-100 mb-5">
                <h2 className="fw-bold text-end">
                  הזינו פרטי התקשרות ואנו נחזור אליכם
                </h2>
                <p className="text-end">
                  נשמח לענות על כל שאלה או בקשה שתהיה לכם, ניתן ליצור קשר בכל עת
                  ואנו נשתדל לחזור אליכם בהקדם
                </p>

                <Form onSubmit={submitHandler}>
                  <Form.Group className="my-3" controlId="email">
                    <Col xs={12}>
                      <Form.Control
                        type="email"
                        placeholder="כתובת מייל"
                        dir="rtl"
                        required
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        disabled={isLoading}
                      ></Form.Control>
                    </Col>
                  </Form.Group>

                  <Form.Group className="my-3" controlId="phone">
                    <Col xs={12}>
                      <Form.Control
                        type="tel"
                        placeholder="טלפון"
                        dir="rtl"
                        required
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                        disabled={isLoading}
                      ></Form.Control>
                    </Col>
                  </Form.Group>

                  <Form.Group className="my-3" controlId="issue">
                    <Col xs={12}>
                      <Form.Control
                        as="textarea"
                        rows="3"
                        placeholder="פרטי פנייה"
                        dir="rtl"
                        required
                        value={issue}
                        onChange={(e) => setIssue(e.target.value)}
                        disabled={isLoading}
                      ></Form.Control>
                    </Col>
                  </Form.Group>

                  <Form.Group className="my-3" controlId="agreement">
                    <Col xs={12}>
                      <div className="d-flex justify-content-end align-items-center">
                        <label
                          htmlFor="agreement"
                          className="text-white me-2"
                          style={{ fontSize: "0.9rem", cursor: "pointer" }}
                        >
                          אני מסכים/ה לתנאי השימוש ולמדיניות הפרטיות של האתר
                        </label>
                        <input
                          type="checkbox"
                          id="agreement"
                          checked={agreed}
                          onChange={(e) => setAgreed(e.target.checked)}
                          disabled={isLoading}
                          style={{
                            width: "18px",
                            height: "18px",
                            accentColor: "#6B46C1",
                            cursor: "pointer",
                          }}
                        />
                      </div>
                    </Col>
                  </Form.Group>

                  <Row className="my-2">
                    <Col className="d-flex justify-content-end">
                      <button
                        type="submit"
                        className="contact_us_button"
                        disabled={isLoading}
                        style={{
                          opacity: isLoading ? 0.8 : 1,
                          cursor: isLoading ? "not-allowed" : "pointer",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "8px",
                        }}
                      >
                        {isLoading ? (
                          <>
                            <Spinner
                              as="span"
                              animation="border"
                              size="sm"
                              role="status"
                              style={{ width: "16px", height: "16px" }}
                            />
                            שולח...
                          </>
                        ) : (
                          "שלח"
                        )}
                      </button>
                    </Col>
                  </Row>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ContactUs;
